// Module
var code = `<div ng-transclude="content"></div><div class="ppm-dropdown__menu" ng-class="{ 'ppm-dropdown__menu--open': \$ctrl.open }" ng-transclude="menu"></div>`;
// Exports
export default code;